import { FC } from 'react';

import constructionSiteImg from 'assets/images/construction-site.svg';
import Text from 'components/_core/Text';
import DecorativeImage from 'components/DecorativeImage';

import Title from '../components/Title';
import Wrapper from '../components/Wrapper';
import locales from './locales';

const PendingTransactions: FC = () => (
  <Wrapper>
    <DecorativeImage src={constructionSiteImg} />
    <Title>{locales.title}</Title>
    <Text size="sm">{locales.body}</Text>
  </Wrapper>
);

export default PendingTransactions;
